import React, { useState }  from 'react'
import { Outlet, Link } from 'react-router-dom';
import { FaAlignJustify,FaAngleDown  } from "react-icons/fa";
import logo from '../img/icon/daarchitecture.png'
import '../componets/navbar.css';
import { useLocation } from 'react-router-dom';

const Navbar = () => {
	const [isMobile, setIsMobile] = useState(false);

	//assigning location variable
	const location = useLocation();

	//destructuring pathname from location
	const { pathname } = location;
	//Javascript split method to get the name of the path in array
	const splitLocation = pathname.split('/');

	return (
		<>
			<nav className="navbar">
				<Link to="/" id="top__logo">
					<img src={logo} alt="top logo" className="da-logo" />
				</Link>
				<ul
					className={isMobile ? 'nav-link-mobile' : 'nav-link'}
					onClick={() => setIsMobile(false)}
				>
					<li className={splitLocation[1] === '' ? 'active' : ''}>
						<Link to="/">Home</Link>
					</li>
					{/* <Link to="/" className="nav-c">
						Home
					</Link> */}
					<li className={splitLocation[1] === 'about' ? 'active' : ''}>
						<Link to="/about">About</Link>
					</li>
					{/* <Link to="/about" className="nav-c">
						About
					</Link> */}
					<li className={splitLocation[1] === 'services' ? 'active' : ''}>
						<Link to="/services">Services</Link>
					</li>
					<li className={splitLocation[1] === 'portfolio' ? 'active' : ''}>
						<Link to="/portfolio">Portfolio</Link>
					</li>
					<li className={splitLocation[1] === 'blog' ? 'active' : ''}>
						<Link to="/blog">Blog</Link>
					</li>
					<li className={splitLocation[1] === 'contact' ? 'active' : ''}>
						<Link to="/contact">Contact</Link>
					</li>
					{/* <Link to="/services" className="nav-c">
						Services
					</Link>
					<Link to="/portfolio" className="nav-c">
						Portfolio
					</Link>
					<Link to="/blog" className="nav-c">
						Blog
					</Link>
					<Link to="/contact" className="nav-c">
						Contact
					</Link> */}
				</ul>
				<button
					className="mobile-menu-icon"
					onClick={() => setIsMobile(!isMobile)}
				>
					{isMobile ? <FaAngleDown /> : <FaAlignJustify />}
				</button>
			</nav>
			<Outlet />
		</>
	);
}

export default Navbar